var LOAD_STATUS;

(function (LOAD_STATUS) {
  LOAD_STATUS["before"] = "loadBefore";
  LOAD_STATUS["start"] = "loadStart";
  LOAD_STATUS["end"] = "loadEnd";
  LOAD_STATUS["after"] = "loadAfter";
})(LOAD_STATUS || (LOAD_STATUS = {}));

export default LOAD_STATUS;